/**
 * COLLECTION FILTERS AJAX ENGINE
 */

class CollectionFilters {
  constructor() {
    this.form = document.querySelector('[data-filter-form]');
    this.grid = document.querySelector('[data-product-grid]');
    if (this.form) this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('change', () => this.applyFilters());
    
    // Grid vs List Toggle
    document.querySelectorAll('[data-view-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.getAttribute('data-view-toggle');
        if (this.grid) {
          this.grid.className = view === 'list' ? 'grid grid-1' : 'grid grid-4';
        }
      });
    });
  }

  async applyFilters() {
    if (!this.form || !this.grid) return;
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    this.grid.style.opacity = '0.5';

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-product-grid]');
      if (newGrid && this.grid) {
        this.grid.innerHTML = newGrid.innerHTML;
      }
      window.history.pushState({}, '', url);
    } catch (e) {
      console.error('Failed to filter products:', e);
    } finally {
      this.grid.style.opacity = '1';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});
